import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Spinner } from '@blueprintjs/core';

import history from '../../../../../helpers/history';

import { loadProgresses, deleteProgress } from '../../../../../redux/actions/progress.actions';

const mapStateToProps = (state) => ({
    progress: state.progress
});
const mapDispatch = {
    loadProgresses,
    deleteProgress
};

const EmptyView = props => {
    return (
        <div className="intro">
            <div className="intro-text">Click here to add a student progress. <span onClick={(event) => props.openModal({ event, rowData: null })} className="link">Add Student Progress</span></div>
        </div>
    );
};

class Progress extends Component {
    componentDidMount() {
        this.props.loadProgresses(this.props.recipientId);
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.recipientId !== nextProps.recipientId) {
            nextProps.loadProgresses(nextProps.recipientId);
        }
    }
    shouldComponentUpdate(nextProps) {
        return (this.props.progress.progresses !== nextProps.progress.progresses) ||
            (this.props.progress.allLoading !== nextProps.progress.allLoading) ||
            (this.props.recipientId !== nextProps.recipientId);
    }
    _renderTableRow = (rowData, i) => {
        return (
            <tr key={i} onClick={() => this.goToProgressDetails(rowData.id)}>
                <td>{rowData.year_begin}</td>
                <td>{rowData.education_level}</td>
                <td>{rowData.student_status}</td>
                <td>{rowData.progress_notes}</td>
                <td className="action-row">
                    <div className="pt-button pt-intent-primary pt-icon-edit pt-small" onClick={(event) => this.props.openModal({ rowData, event })}>Edit</div>
                    <div className="pt-button pt-intent-danger pt-icon-trash pt-small" onClick={(event) => this.openDeleteModal({ rowData, event})}>Delete</div>
                </td>
            </tr>
        );
    }
    goToProgressDetails = id => {
        if (!this.props.match.params.progressId) {
            history.push(`${this.props.match.url}/${id}`);
        }
    }
    openDeleteModal = ({ rowData, event }) => {
        event.preventDefault();
        event.stopPropagation();
        const customEvent = new CustomEvent('open-delete-modal', {
            detail: {
                content: `Are you sure you want to delete this student progress for the year ${rowData.year_begin}?`,
                onDelete: () => {
                    this.props.deleteProgress({ recipientId: this.props.recipientId, progressId: rowData.id });
                }
            }
        });
        window.dispatchEvent(customEvent);
    }
    render() {
        const { progress: { progresses, allLoading }} = this.props;
        return (
            <Fragment>
                { allLoading ? 
                    <div className="spinner-container">
                        <Spinner large />
                    </div> :
                    progresses.length === 0 ?
                        <EmptyView openModal={this.props.openModal} /> :
                        <table className="general-table pt-html-table pt-interactive">
                            <thead>
                                <tr>
                                    <th>School Start</th>
                                    <th>Education Level</th>
                                    <th>Student Status</th>
                                    <th>Progress Notes</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                { progresses.map((progress, i) => this._renderTableRow(progress, i)) }
                            </tbody>
                        </table>
                }
            </Fragment>
        );
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatch
)(Progress));



// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/recipient/RecipientProgress.jsx